module.exports = __webpack_public_path__ + "img/lb.f3370503.png";